import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { PackingModeSchema } from "@redotech/redo-inventory-common/packing-mode";
import { inboundShipmentProductIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const updateShipmentProductPacking = {
  name: "updateShipmentProductPacking" as const,
  input: z.object({
    inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
    packingMode: PackingModeSchema,
    packingTemplateId: packingTemplateIdFormat.schema.nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
